export { 
    setup,
    start,
    getCorrelationContext,
    startOperation,
    wrapWithCorrelationContext,
    Configuration,
    defaultClient,
    Contracts, 
    DistributedTracingModes,
    HttpRequest,
    TelemetryClient,
    dispose,
} from "./src/shim/applicationinsights";